<template>
  <v-container class="ma-0 pa-0" style="max-width: 100%;" fluid>
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>

    <v-card style="height: calc(100vh - 64px);">
      <v-row>
        <v-col v-if="showHistory" cols="3">
          <v-card flat>
            <div class="mr-8 d-flex justify-end">
              <v-btn
                class="back-button"
                color="var(--color-button-history)"
                icon
                @click="showHistory = false"
              >
                <v-icon color="var(--color-icon-history)">
                  mdi-chevron-left
                </v-icon>
              </v-btn>
            </div>
            <v-list class="border-right" style="height: calc(100vh - 80px); overflow-y: auto;">
              <div class="d-flex justify-end pa-2">
                <v-btn
                  class="new-chat-btn justify-start mr-2 ml-2 pl-3"
                  height="40px"
                  width="96%"
                  @click="startNewChat"
                >
                  New Chat
                </v-btn>
              </div>
              <v-list-item v-if="listHistoryChatToday !== undefined">
                <v-list-item-title>
                  <b>Today</b>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-for="item in listHistoryChatToday"
                :key="item.id"
                :class="{
                  'custom-list-item': item.chat_session_id == chatSessionId.chat_session_id,
                  'hover-list-item': hoveredItem == item.chat_session_id
                }"
                @mouseover="hoveredItem = item.chat_session_id"
                @mouseleave="hoveredItem = ''"
                @click="listFollowUpQuestion = '', getDetailChat(item)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.question }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action
                  v-if="item.chat_session_id == chatSessionId.chat_session_id || hoveredItem == item.chat_session_id"
                  @click.stop="showDialogDeleteHistoryChat(item)"
                >
                  <v-icon class="mdi mdi-delete"></v-icon>
                </v-list-item-action>
              </v-list-item>

              <v-list-item v-if="listHistoryChatYesterday !== undefined">
                <v-list-item-title>
                  <b>Yesterday</b>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-for="item in listHistoryChatYesterday"
                :key="item.id"
                :class="{
                  'custom-list-item': item.chat_session_id == chatSessionId.chat_session_id,
                  'hover-list-item': hoveredItem == item.chat_session_id
                }"
                @mouseover="hoveredItem = item.chat_session_id"
                @mouseleave="hoveredItem = ''"
                @click="listFollowUpQuestion = '', getDetailChat(item)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.question }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action
                  v-if="item.chat_session_id == chatSessionId.chat_session_id || hoveredItem == item.chat_session_id"
                  @click.stop="showDialogDeleteHistoryChat(item)"
                >
                  <v-icon class="mdi mdi-delete"></v-icon>
                </v-list-item-action>
              </v-list-item>

              <v-list-item v-if="listHistoryChatPrevious7Days !== undefined">
                <v-list-item-title>
                  <b>Previous 7 Days</b>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-for="item in listHistoryChatPrevious7Days"
                :key="item.id"
                :class="{
                  'custom-list-item': item.chat_session_id == chatSessionId.chat_session_id,
                  'hover-list-item': hoveredItem == item.chat_session_id
                }"
                @mouseover="hoveredItem = item.chat_session_id"
                @mouseleave="hoveredItem = ''"
                @click="listFollowUpQuestion = '', getDetailChat(item)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.question }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action
                  v-if="item.chat_session_id == chatSessionId.chat_session_id || hoveredItem == item.chat_session_id"
                  @click.stop="showDialogDeleteHistoryChat(item)"
                >
                  <v-icon class="mdi mdi-delete"></v-icon>
                </v-list-item-action>
              </v-list-item>

              <v-list-item v-if="listHistoryChatPrevious30Days !== undefined">
                <v-list-item-title>
                  <b>Previous 30 Days</b>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-for="item in listHistoryChatPrevious30Days"
                :key="item.id"
                :class="{
                  'custom-list-item': item.chat_session_id == chatSessionId.chat_session_id,
                  'hover-list-item': hoveredItem == item.chat_session_id
                }"
                @mouseover="hoveredItem = item.chat_session_id"
                @mouseleave="hoveredItem = ''"
                @click="listFollowUpQuestion = '', getDetailChat(item)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.question }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action
                  v-if="item.chat_session_id == chatSessionId.chat_session_id || hoveredItem == item.chat_session_id"
                  @click.stop="showDialogDeleteHistoryChat(item)"
                >
                  <v-icon class="mdi mdi-delete"></v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col
          :cols="showHistory ? 9 : 12"
          :class="{ 'pl-0': !showHistory }"
        >
          <v-btn
            v-if="!showHistory"
            class="mt-2 ml-2 back-button"
            style="position: absolute; top: 10px; left: 10px;"
            color="grey lighten-4"
            icon
            @click="showHistory = true"
          >
            <v-icon color="black">
              mdi-chevron-right
            </v-icon>
          </v-btn>

          <v-row class="d-flex justify-space-between" :class="{ 'ml-7': !showHistory }">
            <v-layout class="d-flex justify-center ma-0 mt-3 pa-0" row wrap>
              <div v-if="showHistory == false" class="mr-3" style="width: 40px;">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="new-chat-btn justify-start pl-3"
                      style="width: 40px; height: 40px; min-width: 40px; padding: 0;"
                      @click="startNewChat"
                    >
                      <v-icon color="white" size="18">
                        mdi-message-plus-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>New Chat</span>
                </v-tooltip>
              </div>
              <v-col class="d-flex ma-0 pa-0" style="height: 45px;" cols="12" sm="2">
                <v-select
                  :items="topicSentiment"
                  item-text="TOPIC"
                  item-value="SEQ_ID"
                  v-model="selectedTopic"
                  class="elevation-0 shadow-0"
                  color="var(--color-theme)"
                  :item-color="themeItemColor"
                  label="Topic"
                  no-data-text="No topic available"
                  dense
                  outlined
                  rounded
                  @change="parameterProsesTopic"
                ></v-select>
              </v-col>

              <v-col class="d-flex ma-0 mx-3 pa-0" style="height: 45px;" cols="12" sm="2">
                <v-select
                  v-model="selectedKeywords"
                  :items="topicKeywordSentiment"
                  class="elevation-0 shadow-0"
                  color="var(--color-theme)"
                  :item-color="themeItemColor"
                  label="Keyword"
                  no-data-text="No keyword available"
                  multiple
                  dense
                  outlined
                  rounded
                  @change="handleMultipleKeyword"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 1" :key="index" small>
                      {{ item }}
                    </v-chip>
                    <span
                      v-if="index == 1"
                      class="text-grey text-caption align-self-center"
                    >
                      (+{{ selectedKeywords.length - 1 }} others)
                    </span>
                  </template>
                </v-select>
              </v-col>

              <v-col class="d-flex ma-0 pa-0" style="height: 45px;" cols="12" sm="2">
                <v-select
                  :items="periodeBerita"
                  item-text="name"
                  item-value="value"
                  v-model="selectedPeriode"
                  class="elevation-0 shadow-0"
                  color="var(--color-theme)"
                  :item-color="themeItemColor"
                  label="Periode"
                  dense
                  outlined
                  rounded
                  @change="parameterProsesPeriode(), selectShowCustomDate()"
                >
                  <template v-slot:append-item>
                    <v-list-item>
                      <v-list-item-title>
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-width="200"
                          offset-x
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small dark width="120" color="var(--color-theme)">
                              Custom
                            </v-btn>
                          </template>
                          <v-card>
                            <v-row class="pa-8" justify="space-around">
                              <v-date-picker
                                v-model="startDate"
                                :show-current="false"
                                class="custom-date-picker"
                                color="var(--color-theme)"
                                @change="selectShowCustomDate"
                              ></v-date-picker>
                              <v-date-picker
                                v-model="endDate"
                                :show-current="false"
                                class="ml-8 custom-date-picker"
                                color="var(--color-theme)"
                                @change="selectShowCustomDate"
                              ></v-date-picker>
                            </v-row>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="#000" text @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn color="var(--color-theme)" text @click="menu = false, parameterProsesCustom()">
                                Set
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>

              <v-col class="d-flex ma-0 ml-3 pa-0" style="height: 45px;" cols="12" sm="2">
                <v-select
                  :items="itemsSource"
                  item-text="NAME_SOCIAL_MEDIA"
                  item-value="valueNAME_SOCIAL_MEDIA"
                  v-model="selectedSource"
                  class="elevation-0 shadow-0"
                  color="var(--color-theme)"
                  :item-color="themeItemColor"
                  label="Source"
                  dense
                  outlined
                  rounded
                  @change="parameterProsesTopic"
                ></v-select>
              </v-col>

              <v-col class="d-flex ma-0 ml-3 pa-0" style="height: 45px;" cols="12" sm="2">
                <v-btn
                  color="var(--color-theme)"
                  height="40"
                  style="max-width: 100%;"
                  dense
                  dark
                  rounded
                  block
                  @click="queryToQdrant"
                >
                  <v-icon>mdi-magnify</v-icon>
                  Apply
                </v-btn>
              </v-col>
              <div class="periode-info">
                Search periode: {{ showStartDate[1] + " " + showStartDate[0] + " " + showStartDate[2] }} - {{ showEndDate[1] + " " + showEndDate[0] + " " + showEndDate[2] }}
              </div>
            </v-layout>
          </v-row>

          <div
            :class="{
              'mt-0': true,
              'mr-5': !$vuetify.breakpoint.xsOnly,
              'ml-8': !showHistory && !$vuetify.breakpoint.xsOnly
            }"
            class="chat-wrapper"
          >
            <div v-if="listResponseMessage != 0" class="my-3"></div>
            <div class="pr-2" style="flex: 1 1 auto; overflow-y: auto; overflow-x: hidden; width: 100%;">
              <div
                v-if="listResponseMessage.length == 0"
                class="empty-chat-wrapper"
              >
                <v-row class="fill-height">
                  <v-col cols="2">
                    <div
                      style="
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        padding-left: 8px;
                      "
                    >
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :disabled="resultSession == ''"
                            :class="{ 'custom-disabled-btn-further-insights': resultSession == '' }"
                            class="ml-2 d-flex align-center justify-center"
                            style="text-transform: none; color: #fff; font-size: 15px; width: 180px;"
                            :style="{ color: resultSession == '' ? 'var(--color-disabled-send)' : 'var(--color-theme)' }"
                          >
                            Further Insights
                            <v-icon class="ml-1" size="20">
                              mdi-chevron-right
                            </v-icon>
                          </v-btn>
                        </template>

                        <v-list style="height: 455px; min-width: 220px;" elevation="4">
                          <v-list-item dense @click="handleContextTalkToLLM('summarize')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-file-document-outline
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Summarize Text
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('sentiment')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-file-chart-outline
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Context Sentiment
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('NER')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-file-account
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Context Entities
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('SWOT_analysis')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-view-grid
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              SWOT Analysis
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('PESTEL_analysis')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-chart-bubble
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              PESTEL Analysis
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('CBA_analysis')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-cash-multiple
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              CB Analysis
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('Scenario_Planning_Simulation')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-chart-timeline-variant
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Scenario Planning & Simulation
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('Policy_Heatmap')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-scale-balance
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Policy Heatmap
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('RACI_matrix')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-table
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Strategic Assignment
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('strategic_assignment')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-format-list-checks
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Strategic Planning
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="handleContextTalkToLLM('press_release_draft')">
                            <v-list-item-icon class="mr-4">
                              <v-icon size="18">
                                mdi-newspaper-variant-outline
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title style="margin-top: 1px;">
                              Press Release Draft
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col cols="8">
                    <div class="empty-chat-container">
                      <div style="display: flex; justify-content: center; width: 100%;">
                        <img :src="logo" height="200px" width="200px" alt="" />
                      </div>
                      <h1
                        class="mt-4"
                        style="
                          font-family: Poppins;
                          font-weight: 700;
                          font-size: 46px;
                          line-height: 100%;
                          letter-spacing: 0;
                          text-align: center;
                          margin: 0;
                          color: var(--color-theme);
                        "
                      >
                        <span v-if="logo && logo.includes('iconmedan')">
                          MedAn AI Insights
                        </span>
                        <span v-else>
                          Garuda AI Insights
                        </span>
                      </h1>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-if="listResponseMessage.length != 0">
                <template>
                  <div
                    v-for="(item, index) in listResponseMessage"
                    :key="index"
                    class="response-container-question"
                  >
                    <div class="response-text-question" v-html="item.question"></div>

                    <div
                      v-if="item.answer"
                      :class="showHistory ? 'pt-4 ml-2 response-container-message' : 'pt-4 ml-3 response-container-message'"
                    >
                      <div class="response-text-message" v-html="formatText(item.answer)"></div>
                    </div>

                    <div v-if="loadingPostTalkToLLM && index == listResponseMessage.length - 1" class="mt-12 ml-6 loading-dots">
                      <span>.</span><span>.</span><span>.</span>
                    </div>
                  </div>
                </template>

                <v-row class="px-4" no-gutters dense>
                  <v-col
                    v-for="(question, index) in listFollowUpQuestion"
                    :key="index"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="d-flex"
                  >
                    <v-card
                      class="ma-2 pa-3 flex-grow-1 hover-card"
                      style="background-color: #f8f8f8; cursor: pointer; text-align: center; word-wrap: break-word; white-space: normal;"
                      elevation="2"
                      @click="handleFollowUpClick(question)"
                    >
                      {{ question }}
                    </v-card>
                  </v-col>
                </v-row>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      :disabled="resultSession == ''"
                      :class="{ 'custom-disabled-btn-further-insights': resultSession == '' }"
                      class="mt-2 ml-3 mb-4 d-flex align-center justify-center"
                      style="text-transform: none; color: #fff; font-size: 15px; width: 180px;"
                      :style="{ color: resultSession == '' ? 'var(--color-disabled-send)' : 'var(--color-theme)' }"
                    >
                      Further Insights
                      <v-icon class="ml-1" size="20">
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-list style="min-width: 220px;" elevation="4">
                    <v-list-item dense @click="handleContextTalkToLLM('summarize')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-file-document-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Summarize Text
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('sentiment')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-file-chart-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Context Sentiment
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('NER')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-file-account
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Context Entities
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('SWOT_analysis')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-view-grid
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        SWOT Analysis
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('PESTEL_analysis')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-chart-bubble
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        PESTEL Analysis
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('CBA_analysis')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-cash-multiple
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        CB Analysis
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('Scenario_Planning_Simulation')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-chart-timeline-variant
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Scenario Planning & Simulation
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('Policy_Heatmap')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-scale-balance
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Policy Heatmap
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('RACI_matrix')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-table
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Strategic Assignment
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('strategic_assignment')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-format-list-checks
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Strategic Planning
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="handleContextTalkToLLM('press_release_draft')">
                      <v-list-item-icon class="mr-4">
                        <v-icon size="18">
                          mdi-newspaper-variant-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-top: 1px;">
                        Press Release Draft
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>

            <div class="chat-input-container">
              <v-card class="d-flex flex-column ml-2 px-4 py-3" style="width: 98.5%;" rounded="xl">
                <v-row class="align-center">
                  <v-col class="ml-3" style="padding: 0">
                    <v-textarea
                      class="custom-textarea mr-6"
                      color="var(--color-theme)"
                      rows="1"
                      placeholder="Please discuss the topic you want to know about"
                      v-model="valueMessage"
                      variant="solo-inverted"
                      height="96px"
                      dense
                      auto-grow
                      hide-details
                      no-resize
                      @keydown.enter.prevent="handleEnterTalkToLLM"
                    />
                  </v-col>
                </v-row>

                <div class="d-flex align-center mt-6">
                  <div class="d-flex align-center">
                    <span style="cursor: pointer" @click="dialogModel = true">
                      {{ selectedChatModel }}
                    </span>
                    <v-menu v-model="dialogModel" offset-y location="end">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="ml-1" color="grey darken-2">
                          mdi-chevron-down
                        </v-icon>
                      </template>
                      <v-card height="270" width="200">
                        <v-card-title>Change model</v-card-title>
                        <v-divider></v-divider>
                        <v-list v-for="item in listChatModel" :key="item">
                          <v-list-item @click="selectedChatModel = item">
                            <v-list-item-title>
                              {{ item }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>

                  <v-spacer></v-spacer>

                  <v-btn
                    :disabled="resultSession == ''"
                    :class="['mr-3', { 'custom-disabled-btn': resultSession == '' }]"
                    style="width: 40px; height: 40px; min-width: 40px; padding: 0;"
                    color="var(--color-theme)"
                    @click="valueTaskType = 'chat', postTalkToLLM()"
                  >
                    <template v-if="!loadingPostTalkToLLM">
                      <v-icon color="white" size="18">
                        mdi-send
                      </v-icon>
                    </template>
                    <template v-else>
                      <v-progress-circular
                        indeterminate
                        size="18"
                        width="2"
                        color="white"
                      />
                    </template>
                  </v-btn>
                </div>
              </v-card>
            </div>
            <div class="my-2"></div>
          </div>
          <div class="py-4"></div>
        </v-col>
      </v-row>

      <v-overlay v-model="overlayDialogLoading">
        <v-dialog v-model="dialogLoading" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h6 font-weight-medium align-center justify-center">
              Page loading
            </v-card-title>
            <v-card-text class="body-1 align-center justify-center">
              Loading content, please wait
            </v-card-text>
            <v-card-title class="align-center justify-center pt-2 pb-4">
              <v-progress-circular
                color="var(--color-theme)"
                :size="70"
                :width="7"
                indeterminate
              ></v-progress-circular>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="var(--color-theme)"
                text
                @click="overlayDialogLoading = false, dialogLoading = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-overlay>

      <v-dialog v-model="dialogQueryToQdrant" persistent max-width="325">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading query to qdrant, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="var(--color-theme)"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="var(--color-theme)" text @click="dialogQueryToQdrant = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDeleteHistoryChat" persistent max-width="400">
        <v-card height="160px">
          <v-card-title class="headline">Delete chat?</v-card-title>
          <v-card-text>Are you sure you want to delete this chat?</v-card-text>
          <v-card-actions class="mb-2">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogDeleteHistoryChat = false">
              Cancel
            </v-btn>
            <v-btn color="red" style="border-radius: 12px" dark @click="deleteHistoryChat">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <div>
      <Notification ref="alert"></Notification>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { decryptionData, generateFilterDate, processTopicKeywords, trackEvent } from "@/components/utils/utils.js";
import Notification from '@/components/Notification';

export default {
  components: {
    Notification: Notification
  },
  data() {
    return {
      logo: null,
      showHistory: true,
      hoveredItem: "",
      dialogDeleteHistoryChat: false,
      deleteChatSessionId: "",
      dialogQueryToQdrant: false,
      chatSessionId: "",
      resultSession: "",
      valueTaskType: "chat",
      dialogModel: false,
      listChatModel: "",
      selectedChatModel: "",
      loadingPostTalkToLLM: false,
      errorTalkToLLM: false,
      listFollowUpQuestion: "",
      selectedFollowUpQuestion: "",
      valueMessage: "",
      responseMessage: "",
      listResponseMessage: [],
      listHistoryChatToday: "",
      listHistoryChatYesterday: "",
      listHistoryChatPrevious7Days: "",
      listHistoryChatPrevious30Days: "",
      overlayDialogLoading: false,
      dialogLoading: false,
      alert: false,
      colorAlert: "",
      message: "",
      selectedTopic: "",
      selectedKeyword: "",
      selectedKeywords: ["All"],
      selectedPeriode: "This Week",
      topicSentiment: [],
      topicKeywordSentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      menu: false,
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      isShowDate: false,
      showStartDate: "",
      showEndDate: "",
      itemsSource: "",
      selectedSource: "",
    };
  },
  computed: {
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
  },
  async created() {
    await this.loadAssetsTheme();
  },
  mounted() {
    this.loadTopic();
    this.getChatModel();
    this.getHistoryChat();
    this.scrollToTop();
  },
  methods: {
    async loadAssetsTheme() {
      try {
        const appTitle = window.APP_CONFIG?.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
        const assetsModule = appTitle == "Websitemedan"
          ? await import('@/constants/asset-logo-MedAn.js')
          : await import('@/constants/asset-logo-Garuda.js');

        this.logo = assetsModule.LOGO_ICON;
      } catch (error) {
        console.error('Failed to load environment assets:', error);
      }
    },
    handleMultipleKeyword(newVal) {
      const all = 'All';

      if (newVal.includes(all)) {
        if (newVal.length > 1) {
          this.selectedKeywords = newVal.filter(k => k != all);
        }
        if (newVal.length > 1 && newVal[newVal.length - 1] == "All") {
          this.selectedKeywords = [all];
        }
      } else {
        this.selectedKeywords = newVal;
      }
    },
    handleContextTalkToLLM(taskType) {
      if (this.resultSession != "") {
        this.valueTaskType = taskType;
        this.postTalkToLLM();
      }
    },
    handleEnterTalkToLLM() {
      if (this.resultSession != "") {
        this.valueTaskType = "chat";
        this.postTalkToLLM();
      }
    },
    async handleFollowUpClick(question) {
      this.selectedFollowUpQuestion = question;
      this.valueMessage = question;
      this.valueTaskType = "chat";
      await this.postTalkToLLM();
      this.selectedFollowUpQuestion = "";
    },
    startNewChat() {
      this.listResponseMessage = [];
      this.listFollowUpQuestion = "";
      this.chatSessionId = "";
      this.resultSession = "";
    },
    async queryToQdrant() {
      
      this.dialogQueryToQdrant = true;
      this.alert = false;
      this.colorAlert = "";
      this.message = "";
      try {
        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_app')}`,
          },
        });

        let valueKeyword = "";

        if (this.selectedKeywords == "All") {
          valueKeyword = this.topicKeywordSentiment.filter(k => k != "All");
        } else {
          valueKeyword = [];
          valueKeyword = this.selectedKeywords;
        }

        const limitValue = this.selectedSource == "news" ? 5 : 1000;

        trackEvent("gen-ai", { keyword: valueKeyword.join(), source: this.selectedSource });

        const response = await axiosInstance.post(
          "/gen-ai-medan/api/v1/chat/query-by-keywords",
          {
            start_date: this.startDate,
            end_date: this.endDate,
            source: this.selectedSource,
            keywords: valueKeyword,
            limit: limitValue
          }
        );
        if (this.chatSessionId.chat_session_id == "queryToQdrant" || this.chatSessionId == "") {
          this.chatSessionId = {"chat_session_id": response.data.data.chat_session_id, "type": "queryToQdrant"};
        }
        this.resultSession = response.data.data.result;
        this.dialogQueryToQdrant = false;
      } catch (error) {
        this.dialogQueryToQdrant = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "No result found, please check your keywords or try again";
        this.colorAlert = "red";
      }
    },
    async getChatModel() {
      try {
        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_app')}`,
          },
        });

        const response = await axiosInstance.get(
          `/gen-ai-medan/api/v1/chat/models`
        );
        this.listChatModel = [...new Set(response.data.data)];
        this.selectedChatModel = this.listChatModel[0];
      } catch (error) {
        console.error(error);
      }
    },
    async postTalkToLLM() {
      if (this.loadingPostTalkToLLM == false) {
        let newMessage = { question: "", answer: "" };

        const taskMap = {
          chat: this.valueMessage,
          summarize: "Generate context summarization",
          sentiment: "Generate sentiment analysis of the context",
          NER: "Generate named entity recognition of the context",
          SWOT_analysis: "Generate SWOT Analysis from Context",
          PESTEL_analysis: "Generate PESTEL Analysis from Context",
          CBA_analysis: "Generate CBA Analysis from Context",
          Scenario_Planning_Simulation: "Generate Scenario Planning & Simulation from Context",
          Policy_Heatmap: "Generate Policy Heatmap from Context",
          RACI_matrix: "Generate Strategic Assignment from Context",
          strategic_assignment: "Generate Strategic Planning from Context",
          press_release_draft: "Generate Press Release Draft"
        };

        newMessage.question = taskMap[this.valueTaskType] || "";

        this.listResponseMessage.push(newMessage);
        this.listFollowUpQuestion = "";
        this.loadingPostTalkToLLM = true;

        trackEvent("gen-ai-talk", { question: this.valueMessage, model: this.selectedChatModel, task: this.valueTaskType });

        try {
          const axiosInstance = axios.create({
            baseURL: "/apigenerativeAI",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token_app")}`,
            },
          });

          const response = await axiosInstance.post(
            "/gen-ai-medan/api/v1/chat/talk-to-llm",
            {
              data: this.resultSession,
              query: this.valueMessage,
              model_name: this.selectedChatModel,
              task_type: this.valueTaskType,
              chat_session_id: this.chatSessionId.chat_session_id,
            }
          );

          this.errorTalkToLLM = false;
          this.valueMessage = "";

          let rawResponse = "";

          if (response.data.data.response) {
            rawResponse = response.data.data.response;
          }

          let answer = "";
          let followUps = [];

          const followUpPattern = /<question_\d+>\s*([^\n\t]+)/g;
          let match;

          while ((match = followUpPattern.exec(rawResponse)) !== null) {
            if (match[1]) {
              followUps.push(match[1].trim());
            }
          }

          if (followUps.length > 0) {
            answer = rawResponse.replace(followUpPattern, "").trim();
            followUps = followUps.slice(0, 3);
          } else {
            const lines = rawResponse
              .split(/[\n\t]/)
              .map(line => line.trim())
              .filter(Boolean);

            const firstQuestionIndex = lines.findIndex(line => line.endsWith("?"));

            if (firstQuestionIndex != -1) {
              answer = lines.slice(0, firstQuestionIndex).join(" ").trim();

              followUps = lines
                .slice(firstQuestionIndex)
                .flatMap(line => line.split("?"))
                .map(line => line.trim())
                .filter(line => line.length > 0)
                .map(line => line.replace(/^[-\d.]+\s*/, "") + "?")
                .slice(0, 3);
            } else {
              answer = rawResponse.trim();
            }
          }

          const lastIndex = this.listResponseMessage.length - 1;
          this.listResponseMessage[lastIndex].answer = answer;
          this.responseMessage = answer;
          this.listFollowUpQuestion = followUps;

          this.listResponseMessage.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
          this.loadingPostTalkToLLM = false;

          const item = {
            chat_session_id: this.chatSessionId.chat_session_id,
            question: this.resultSession,
          };
          this.getDetailChat(item);
          this.getHistoryChat();
        } catch (error) {
          console.error("Error talk with posts:", error);
          const errorMessage = "The server is busy. Please try again later.";
          const lastIndex = this.listResponseMessage.length - 1;
          this.listResponseMessage[lastIndex].answer = errorMessage;
          this.responseMessage = errorMessage;
          this.listResponseMessage.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
          this.loadingPostTalkToLLM = false;
          this.errorTalkToLLM = true;

          setTimeout(() => {
            this.errorTalkToLLM = false;
          }, 5000);
        }
      }
    },
    async getHistoryChat() {
      try {
        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_app')}`,
          },
        });

        const response = await axiosInstance.get("/gen-ai-medan/api/v2/chat/history");
        this.listHistoryChatToday = response.data.data.Today;
        if (this.listHistoryChatToday !== undefined) {
          this.listHistoryChatToday = response.data.data.Today.sort((a, b) =>
            new Date(b.created_at) - new Date(a.created_at)
          );
        }
        this.listHistoryChatYesterday = response.data.data.Yesterday;
        if (this.listHistoryChatYesterday !== undefined) {
          this.listHistoryChatYesterday = response.data.data.Yesterday.sort((a, b) =>
            new Date(b.created_at) - new Date(a.created_at)
          );
        }
        this.listHistoryChatPrevious7Days = response.data.data.Previous7Days;
        if (this.listHistoryChatPrevious7Days !== undefined) {
          this.listHistoryChatPrevious7Days = response.data.data.Previous7Days.sort((a, b) =>
            new Date(b.created_at) - new Date(a.created_at)
          );
        }
        this.listHistoryChatPrevious30Days = response.data.data.Previous30Days;
        if (this.listHistoryChatPrevious30Days !== undefined) {
          this.listHistoryChatPrevious30Days = response.data.data.Previous30Days.sort((a, b) =>
            new Date(b.created_at) - new Date(a.created_at)
          );
        }
      } catch (error) {
        console.error(error);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Chat History Internal Server Error";
        this.colorAlert = "red";
      }
    },
    showDialogDeleteHistoryChat(item) {
      this.deleteChatSessionId = item.chat_session_id;
      this.dialogDeleteHistoryChat = true;
    },
    async deleteHistoryChat() {
      this.dialogDeleteHistoryChat = false;
      try {
        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_app')}`,
          },
        });

        const response = await axiosInstance.delete(`/gen-ai-medan/api/v1/chat/history/${this.deleteChatSessionId}`);
        if (response.data.statusCode == "200") {
          this.getHistoryChat();
          if (this.deleteChatSessionId == this.chatSessionId.chat_session_id) {
            this.listResponseMessage = [];
            this.listFollowUpQuestion = "";
          }
        }
      } catch (error) {
        console.error(error);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Delete Chat History Internal Server Error";
        this.colorAlert = "red";
      }
    },
    async getDetailChat(item) {
      trackEvent("gen-ai-chat", { chat: item.chat_session_id });

      this.alert = false;
      this.colorAlert = "";
      this.message = "";
      this.chatSessionId = {
        chat_session_id: item.chat_session_id,
        type: "detailChat"
      };

      try {
        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token_app")}`,
          },
        });

        const response = await axiosInstance.get(
          `/gen-ai-medan/api/v2/chat/detail/${item.chat_session_id}`
        );

        this.listResponseMessage = response.data.data.map(item => {
          let rawAnswer = item.answer;

          if (rawAnswer.includes("PRESS RELEASE") && rawAnswer.endsWith("###")) {
            rawAnswer = rawAnswer.substring(0, rawAnswer.length - 3).trim();
          }

          let cleanAnswer = rawAnswer;

          const followUpMarkers = [
            /Apa yang dapat kami bantu lebih lanjut\??/i,
            /Apa pertanyaan lanjutan yang mungkin/i,
            /Apa langkah[- ]konkret yang/i,
            /Kemungkinan pertanyaan lanjutan:/i,
            /Kemungkinan pertanyaan yang mungkin/i,
            /Berikut adalah pertanyaan lanjutan yang mungkin ditanyakan oleh pengguna terkait topik ini:/i,
            /Pertanyaan lanjutan yang mungkin ditanyakan oleh pengguna:/i,
            /Berikut pertanyaan lanjutan yang mungkin diajukan(?: pengguna)?:/i,
            /Pertanyaan lanjutan yang mungkin diajukan:/i,
            /Berikut adalah pertanyaan lanjutan yang mungkin muncul:/i,
            /Pertanyaan lanjutan yang mungkin pengguna ingin tahu:/i,
            /Berikut adalah beberapa pertanyaan lanjutan yang mungkin muncul berdasarkan topik di atas:/i,
            /Berikut beberapa pertanyaan lanjutan yang mungkin diajukan:/i,
            /Berikut adalah beberapa pertanyaan lanjutan yang mungkin Anda tanyakan:/i,
            /Pertanyaan lanjut yang mungkin ditanyakan pengguna:/i,
            /Beberapa pertanyaan lanjutan yang mungkin[^\n]*/i,
            /\*\*Pertanyaan [Ll]anjutan\*\*/,
            /Pertanyaan [Ll]anjutan/,
            /\*\*Pertanyaan [Tt]indak [Ll]anjut/,
            /Pertanyaan [Tt]indak [Ll]anjut/,
            /Suggested follow-up questions:/i,
            /Suggest questions:/i,
            /Suggested Questions:/i,
            /Saran pertanyaan lanjutan:/i,
            /\*\*Saran Pertanyaan Tindak Lanjut:/i,
            /Saran Pertanyaan Tindak Lanjut:/i,
            /\*\*Pertanyaan Mengikuti/i,
            /Pertanyaan Mengikuti/i,
            /#{1,6}\s*Pertanyaan [Tt]indak [Ll]anjut/i,
            /#{1,6}\s*Pertanyaan [Ll]anjutan/i,
            /#{1,6}\s*Follow[- ]?up Questions?/i,
            /\*\*Pertanyaan [Ll]anjut/i,
            /Pertanyaan [Ll]anjut/i,
            /---\s*\n+Dari sini,?\s*selalu beserta beberapa/i,
            /Dari sini,?\s*selalu beserta beberapa/i,
            /#{1,6}\s*Pertanyaan yang Mungkin Diajukan/i,
            /\*\*Pertanyaan yang Mungkin Diajukan/i,
            /Pertanyaan yang Mungkin Diajukan/i,
            /\*\*Kalimat Tanya Lanjutan/i,
            /Kalimat Tanya Lanjutan/i,
            /^\s*(?:\*{0,2}\s*)?(?:Berikut(?:\s+adalah)?\s+)?(?:beberapa\s+)?pertanyaan\s+(?:lanjutan|lanjut|tindak\s*lanjut)/im,
            /^\s*(?:\*{0,2}\s*)?kemungkinan\s+pertanyaan/im,
            /^\s*(?:\*{0,2}\s*)?saran\s+pertanyaan/im,
            /^\s*(?:\*{0,2}\s*)?pertanyaan\s+yang\s+mungkin\s+(?:diajukan|muncul|ditanyakan)/im,
          ];

          let earliestCutIndex = -1;
          for (const marker of followUpMarkers) {
            const match = cleanAnswer.match(marker);
            if (match && match.index !== undefined) {
              if (earliestCutIndex === -1 || match.index < earliestCutIndex) {
                earliestCutIndex = match.index;
              }
            }
          }
          if (earliestCutIndex !== -1) {
            cleanAnswer = cleanAnswer.substring(0, earliestCutIndex).trim();
          }

          const paragraphs = cleanAnswer.split('\n\n').filter(p => p.trim() != '');
          for (let i = paragraphs.length - 1; i >= 0; i--) {
            const paragraph = paragraphs[i];
            const lines = paragraph.split(/[\n\t]/).filter(line => line.trim() != '');

            const questionLines = lines.filter(line => {
              const sanitizedLine = line.trim().replace(/^[*_]+|[*_]+$/g, '');
              return sanitizedLine.endsWith('?') ||
                sanitizedLine.startsWith('Apa ') ||
                sanitizedLine.startsWith('Bagaimana ') ||
                sanitizedLine.startsWith('Mengapa ') ||
                sanitizedLine.startsWith('Siapa ') ||
                sanitizedLine.startsWith('Kapan ') ||
                sanitizedLine.startsWith('Di mana ') ||
                sanitizedLine.startsWith('Apakah ');
            });

            if (questionLines.length >= 1 && (questionLines.length / lines.length >= 0.5)) {
              cleanAnswer = paragraphs.slice(0, i).join('\n\n').trim();
            } else if (paragraph.trim() == '---') {
              cleanAnswer = paragraphs.slice(0, i).join('\n\n').trim();
            } else {
              break;
            }
          }

          const lines = cleanAnswer.replace(/\r/g, '').split('\n');
          let processedSections = [];
          let currentSection = "";
          let isInSpecialSection = false;

          lines.forEach((line, index) => {
            const trimmed = line.trim();
            if (!trimmed && !currentSection) return;

            const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
            if (headingMatch) {
              const level = headingMatch[1].length;
              const headingText = headingMatch[2];

              if (level <= 2 && (
                headingText.includes("Analisis") ||
                headingText.includes("Rekomendasi") ||
                headingText.includes("SWOT") ||
                headingText.includes("PESTEL") ||
                headingText.includes("CBA") ||
                headingText.includes("Skenario")
              )) {
                if (currentSection) {
                  processedSections.push(currentSection.trim());
                }
                currentSection = trimmed;
                isInSpecialSection = true;
              } else if (isInSpecialSection && level >= 3 && level <= 4) {
                currentSection += '\n' + trimmed;
              } else if (level <= 2) {
                if (currentSection) {
                  processedSections.push(currentSection.trim());
                  currentSection = "";
                }
                currentSection = trimmed;
                isInSpecialSection = false;
              } else {
                currentSection += '\n' + trimmed;
              }
            } else {
              if (trimmed || currentSection) {
                currentSection += '\n' + (trimmed || line);
              }
            }

            if (index == lines.length - 1 && currentSection) {
              processedSections.push(currentSection.trim());
            }
          });

          if (processedSections.length > 0) {
            cleanAnswer = processedSections.join('\n\n');
          }

          cleanAnswer = cleanAnswer.replace(/(\n\s*#{1,6}\s*)+$/g, '').trim();
          cleanAnswer = cleanAnswer.replace(/(\n?\s*\*{1,3}\s*)+$/g, '').trim();
          cleanAnswer = cleanAnswer.replace(/(Berikut adalah|Berikut|Di akhir,?\s*beberapa|Apa yang dapat kami bantu lebih lanjut)\s*$/i, '').trim();
          cleanAnswer = cleanAnswer.replace(/(\*\*?(Naskah|Pertanyaan|Saran|Usulan)[^\n]*)$/i, '').trim();
          cleanAnswer = cleanAnswer.replace(/\n?---\s*$/g, '').trim();

          cleanAnswer = cleanAnswer.replace(/\*\*NER:\*\*\s*\n-\s*(\n|$)/g, '**NER:**\n');
          cleanAnswer = cleanAnswer.replace(/^\|\s*([^|]+?)\s*\|\s*$/gm, (match, content) => content.trim());

          return {
            ...item,
            answer: cleanAnswer,
            sections: processedSections.length > 0 ? processedSections : null
          };
        }).sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      } catch (error) {
        console.error(error);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Chat Detail Internal Server Error";
        this.colorAlert = "red";
      }
    },
    formatText(text) {
      if (!text) return "";

      let processedText = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
      processedText = processedText.replace(/\*(.+?)\*/g, '<em>$1</em>');

      const hasMarkdownTable = /\|.+\|/.test(processedText);

      if (hasMarkdownTable) {
        return this.formatTextStandard(processedText);
      }

      const hasHeadings = processedText.includes('#');
      if (hasHeadings) {
        return this.formatTextWithHeadings(processedText);
      }

      return this.formatTextStandard(processedText);
    },
    formatTextWithHeadings(text) {
      if (!text) return "";

      const lines = text.split('\n');
      let htmlOutput = '';

      lines.forEach(line => {
        let trimmed = line.trim();

        if (!trimmed && line == '') {
          htmlOutput += '';
          return;
        }

        if (!trimmed) return;

        if (trimmed == '---' || trimmed == '***' || trimmed == '___') {
          htmlOutput += '<hr style="border: none; border-top: 1px solid #ddd; margin: 16px 0;">';
          return;
        }

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const content = headingMatch[2];

          htmlOutput += `<h${level} style="margin-bottom: 10px; line-height: 1.5;">${content}</h${level}>`;
        } else if (/^\d+\./.test(trimmed)) {
          htmlOutput += `<p style="margin-bottom: 10px; line-height: 1.5;">${trimmed}</p>`;
        } else if (trimmed.startsWith('- ')) {
          htmlOutput += `<p style="margin-bottom: 10px; line-height: 1.5;">${trimmed}</p>`;
        } else {
          htmlOutput += `<p style="margin-bottom: 10px; line-height: 1.5;">${trimmed}</p>`;
        }
      });

      return htmlOutput;
    },
    formatTextStandard(text) {
      if (!text) return "";

      const lines = text.split('\n').map(line => line.trim());

      let outputHtml = '';
      let inTable = false;
      let tableHeaderProcessed = false;
      let pendingHeaderRow = null;
      let inList = false;
      let inNotesList = false;
      let inLegend = false;
      let currentListItemContent = '';
      let isHeatmapTable = false;
      let isHeatmapLegendTable = false;

      lines.forEach((line, index) => {
        if (!line) return;

        if (line == '---' || line == '***' || line == '___') {
          if (inTable) {
            outputHtml += `</tbody>\n</table>\n\n`;
            inTable = false;
            tableHeaderProcessed = false;
            isHeatmapTable = false;
            isHeatmapLegendTable = false;
          }
          if (inList) {
            outputHtml += `</ol>`;
            inList = false;
          }
          if (inNotesList) {
            inNotesList = false;
          }
          if (inLegend) {
            inLegend = false;
          }
          outputHtml += `<hr style="border: none; border-top: 1px solid #ddd; margin: 16px 0;">`;
          return;
        }

        const headingMatch = line.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
            isHeatmapLegendTable = false;
          }

          const level = headingMatch[1].length;
          const content = headingMatch[2];

          if (/policy heatmap|heatmap kebijakan|heatmap berdasarkan isu|prioritas intervensi sektor/i.test(content)) {
            isHeatmapTable = true;
            isHeatmapLegendTable = false;
          } else if (/interpretasi|legenda/i.test(content)) {
            isHeatmapLegendTable = true;
            isHeatmapTable = false;
          } else {
            if (level <= 2) {
              isHeatmapTable = false;
              isHeatmapLegendTable = false;
            }
          }

          outputHtml += `<h${level} style="margin-bottom: 12px; line-height: 1.4;">${content}</h${level}>\n`;
          return;
        }

        if (
          line.includes("Heatmap Kebijakan") ||
          line.includes("Policy Heatmap") ||
          line.includes("Heatmap Berdasarkan Isu") ||
          line.includes("Prioritas Intervensi Sektor")
        ) {
          isHeatmapTable = true;
          outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;"><strong>${line}</strong></p>\n`;
          return;
        }

        if (
          line.includes("<strong>Interpretasi") ||
          line.includes("Interpretasi atau Legenda") ||
          line.includes("Interpretasi dan Legenda") ||
          line.includes("Legenda Heatmap")
        ) {
          isHeatmapLegendTable = true;
        }

        if (line == "---") {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
            isHeatmapTable = false;
            isHeatmapLegendTable = false;
          }
          if (inList) {
            outputHtml += `</ol>`;
            inList = false;
          }
          if (inNotesList) {
            inNotesList = false;
          }
          if (inLegend) {
            inLegend = false;
          }
          outputHtml += `<hr style="margin: 15px 0;">`;
          return;
        }

        if (line.startsWith('###')) {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
            isHeatmapTable = false;
            isHeatmapLegendTable = false;
          }

          const headingText = line.replace(/^###\s*/, '');

          if (/heatmap berdasarkan isu|heatmap kebijakan|policy heatmap|prioritas intervensi/i.test(headingText)) {
            isHeatmapTable = true;
            isHeatmapLegendTable = false;
          } else if (/interpretasi|legenda/i.test(headingText)) {
            isHeatmapLegendTable = true;
            isHeatmapTable = false;
          }

          outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;"><strong>${headingText}</strong></p>\n`;
          return;
        }

        if (line.includes("RACI Matrix")) {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
          }
          outputHtml += `<h3 style="margin-top: 20px; margin-bottom: 10px;">${line}</h3>`;
          return;
        }

        if (line.startsWith('<strong>Scenario:')) {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
          }

          const scenarioContent = line.replace(/<\/?strong>/g, '').replace(/^Scenario:/i, '').trim();
          outputHtml += `<h4 style="margin-top: 15px; margin-bottom: 10px;">Scenario: ${scenarioContent}</h4>\n`;
          return;
        }

        if (line.startsWith('|') && line.endsWith('|') && line.toLowerCase().includes('scenario:')) {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
          }
          const scenarioLine = line.replace(/\|/g, '').trim();
          outputHtml += `<h4 style="margin-top: 15px; margin-bottom: 10px;">${scenarioLine}</h4>\n`;
          return;
        }

        if (line.includes("<strong>Legend:</strong>") || line.includes("Interpretasi Legenda")) {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
            isHeatmapTable = false;
            isHeatmapLegendTable = false;
          }
          if (!line.startsWith('###')) {
            outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;"><strong>Legend:</strong></p>\n`;
          }
          inLegend = true;
          return;
        }

        if (line.match(/^\d+\.\s*<strong>(Tinggi|Sedang|Rendah|High|Medium|Low):/)) {
          const parts = line.split('</strong>');
          if (parts.length > 1) {
            outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;">${parts[0]}</strong>${parts[1]}</p>\n`;
          } else {
            outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;">${line}</p>\n`;
          }
          return;
        }

        if (line.startsWith('- ') && inLegend) {
          outputHtml += `  <li>${line.substring(2).trim()}</li>\n`;
          return;
        }

        if (line.includes('<strong>Catatan:</strong>') || line.toLowerCase().includes('notes:')) {
          if (inTable) {
            outputHtml += `  </tbody>\n</table>\n`;
            inTable = false;
            tableHeaderProcessed = false;
            isHeatmapTable = false;
            isHeatmapLegendTable = false;
          }
          if (inList) {
            outputHtml += `</ol>`;
            inList = false;
          }
          if (inLegend) {
            inLegend = false;
          }
          outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;"><strong>Catatan:</strong></p>\n`;
          inNotesList = true;
          return;
        }

        if (line.startsWith('- ') && inNotesList) {
          outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;">${line.substring(2).trim()}</p>\n`;
          return;
        }

        if ((inNotesList || inLegend) && !line.startsWith('- ') && !line.match(/^\d+\.\s*<strong>/)) {
          if (inNotesList) {
            inNotesList = false;
          }
          if (
            inLegend &&
            !line.includes('Berdasarkan') &&
            !line.includes('Pengamatan') &&
            !line.includes('Dengan demikian') &&
            !line.includes('Namun')
          ) {
            inLegend = false;
          }
        }

        if (line.match(/^\|[-\s|:]+\|$/)) {
          if (pendingHeaderRow && !tableHeaderProcessed) {
            outputHtml += `<table style="border-collapse: collapse; width: 100%; margin-bottom: 15px;">\n`;
            outputHtml += `  <thead>\n    <tr>\n`;
            pendingHeaderRow.forEach(cell => {
              outputHtml += `      <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">${cell}</th>\n`;
            });
            outputHtml += `    </tr>\n  </thead>\n  <tbody>\n`;
            tableHeaderProcessed = true;
            inTable = true;
            pendingHeaderRow = null;
          }
          return;
        }

        if (line.startsWith('|') && line.endsWith('|')) {
          const cells = line.split('|').map(cell => cell.trim()).filter(cell => cell.length > 0);

          if (!tableHeaderProcessed && !inTable) {
            pendingHeaderRow = cells;

            const nextLine = lines[index + 1];
            if (nextLine && nextLine.match(/^\|[-\s|:]+\|$/)) {
              return;
            } else {
              outputHtml += `<table style="border-collapse: collapse; width: 100%; margin-bottom: 15px;">\n`;
              outputHtml += `  <thead>\n    <tr>\n`;
              cells.forEach(cell => {
                outputHtml += `      <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">${cell}</th>\n`;
              });
              outputHtml += `    </tr>\n  </thead>\n  <tbody>\n`;
              tableHeaderProcessed = true;
              inTable = true;
              pendingHeaderRow = null;
              return;
            }
          }

          if (inTable) {
            outputHtml += `    <tr>\n`;
            cells.forEach((cell, cellIndex) => {
              let style = "border: 1px solid #ddd; padding: 8px;";
              let cellContent = cell;

              if (isHeatmapLegendTable && cellIndex == 1) {
                const cellLower = cell.toLowerCase();
                if (cellLower.includes('prioritas tinggi') || cellLower.includes('isu ini memiliki dampak signifikan')) {
                  style += " background-color: #ff4444; color: black;";
                } else if (cellLower.includes('prioritas sedang') || cellLower.includes('meskipun penting')) {
                  style += " background-color: #ffa500; color: black;";
                } else if (cellLower.includes('prioritas rendah') || cellLower.includes('isu ini kurang mendesak')) {
                  style += " background-color: #ffff00; color: black;";
                } else if (cellLower.includes('status stabil') || cellLower.includes('isu ini saat ini terkelola')) {
                  style += " background-color: #90ee90; color: black;";
                }
              }

              if (isHeatmapTable && cellIndex == 1) {
                const cellLower = cell.toLowerCase();
                if (
                  cellLower.includes('sangat tinggi') ||
                  cellLower.includes('very high') ||
                  cellLower.includes('critical')
                ) {
                  style += " background-color: #ff4444; color: black;";
                } else if (
                  cellLower.includes('merah') ||
                  (cellLower.includes('tinggi') && cellLower.includes('(')) ||
                  cellLower == 'tinggi' ||
                  cellLower.startsWith('tinggi')
                ) {
                  style += " background-color: #ff4444; color: black;";
                } else if (
                  cellLower.includes('oranye') ||
                  (cellLower.includes('sedang') && cellLower.includes('(')) ||
                  cellLower == 'sedang' ||
                  cellLower.startsWith('sedang')
                ) {
                  style += " background-color: #ffa500; color: black;";
                } else if (
                  cellLower.includes('kuning') ||
                  (cellLower.includes('rendah') && cellLower.includes('(')) ||
                  cellLower == 'rendah' ||
                  cellLower.startsWith('rendah')
                ) {
                  style += " background-color: #ffff00; color: black;";
                } else if (
                  cellLower.includes('hijau') ||
                  cellLower.includes('sangat rendah') ||
                  cellLower.includes('very low') ||
                  cellLower == 'hijau'
                ) {
                  style += " background-color: #90ee90; color: black;";
                } else if (cellLower == 'merah' || cellLower.startsWith('tinggi')) {
                  style += " background-color: #ff4444; color: black;";
                } else if (cellLower == 'oranye' || cellLower.startsWith('sedang')) {
                  style += " background-color: #ffa500; color: black;";
                } else if (cellLower == 'kuning' || cellLower.startsWith('rendah')) {
                  style += " background-color: #ffff00; color: black;";
                } else if (cellLower == 'hijau') {
                  style += " background-color: #90ee90; color: black;";
                }
              }

              outputHtml += `      <td style="${style}">${cellContent}</td>\n`;
            });
            outputHtml += `    </tr>\n`;
          }
          return;
        }

        if (inTable && !line.startsWith('|')) {
          outputHtml += `  </tbody>\n</table>\n`;
          inTable = false;
          tableHeaderProcessed = false;
          isHeatmapTable = false;
          isHeatmapLegendTable = false;
        }

        const listNumberMatch = line.match(/^(\d+)\.\s/);
        if (listNumberMatch && !inLegend) {
          const listNumber = parseInt(listNumberMatch[1]);
          if (!inList) {
            outputHtml += `<ol style="margin-top: 10px; padding-left: 20px;" start="${listNumber}">`;
            inList = true;
          } else if (currentListItemContent) {
            outputHtml += `${currentListItemContent}</li>`;
            currentListItemContent = '';
          }

          const listItemContent = line.replace(/^\d+\.\s/, '');
          currentListItemContent = listItemContent;

          let i = index + 1;
          while (i < lines.length && !lines[i].match(/^\d+\.\s/) && lines[i].trim()) {
            if (lines[i].startsWith('- ') || lines[i].includes('<strong>Entitas') || lines[i].includes('<strong>Langkah:')) {
              currentListItemContent += `<span style="display: block; margin-top: 5px;">${lines[i]}</span>`;
              lines[i] = '';
            }
            i++;
          }

          outputHtml += `<li style="margin-bottom: 12px; line-height: 1.5;">${currentListItemContent}</li>`;
          currentListItemContent = '';
          return;
        }

        if (inList && !line.match(/^\d+\.\s/)) {
          outputHtml += `</ol>`;
          inList = false;
        }

        if (line && !inList && !inTable && !inNotesList && !inLegend && line != '' && !line.match(/^\d+\.\s*<strong>/)) {
          outputHtml += `<p style="margin-bottom: 10px; line-height: 1.5;">${line}</p>\n`;
        }
      });

      if (inTable) outputHtml += `  </tbody>\n</table>\n`;
      if (inList) outputHtml += `</ol>`;

      return outputHtml;
    },
    async loadTopic() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const [keywordSelectResponse, topicKeywordResponse] = await Promise.all([
          axios.get("keyword_select", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          }),
          axios.get("topic-keyword", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          })
        ]);

        const dataDecryption = decryptionData(keywordSelectResponse.data.token);
        const data = dataDecryption.keyword;
        const collections = dataDecryption.collection;

        const topicKeywordData = decryptionData(topicKeywordResponse.data.token);
        const topicKeywordList = topicKeywordData.data.filter(item => item.GROUP_STATUS == 1);

        const completedTopicData = processTopicKeywords(data, collections, topicKeywordList);

        for (let i = 0; i < completedTopicData.length; i++) {
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = completedTopicData[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicSentiment.push(completedTopicData[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicSentiment.length; i++) {
            if (this.selectedTopic == this.topicSentiment[i].TOPIC) {
              this.selectedTopic = this.topicSentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          topickeywordsentiment_glob: completedTopicData,
        });

        this.topicKeywordSentiment = [];
        let all = "All";

        for (let i = 0; i < completedTopicData.length; i++) {
          if (completedTopicData[i].SEQ_ID == this.selectedTopic) {
            this.topicKeywordSentiment.push(all);

            for (let x = 0; x < completedTopicData[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              this.topicKeywordSentiment.push(completedTopicData[i].KEYWORD[x].KEYWORD);
            }
          }
        }

        this.isShowDate = this.$store.is_show_date_glob;
        var fromDate = this.startDate;
        var untilDate = this.endDate;

        if (this.$store.jenis_parameter_glob == "custom") {
          fromDate = this.$store.date_start_glob;
          untilDate = this.$store.date_end_glob;
        } else {
          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let dateGenerate = generateFilterDate(periode);
          fromDate = dateGenerate.start_date;
          untilDate = dateGenerate.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: fromDate,
            date_end_glob: untilDate,
            data_source_glob: this.selectedSource,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.startDate = this.$store.date_start_glob;
          this.endDate = this.$store.date_end_glob;
        }

        if (this.selectedSource == "" || this.selectedSource === undefined) {
          if (this.$store.data_source_glob == "" || this.$store.data_source_glob === undefined) {
            this.$store.data_source_glob = "news";
          }
          this.selectedSource = this.$store.data_source_glob;
        }

        this.getSource();

        if (this.selectedPeriode == "Custom") {
          this.selectShowCustomDate();
        } else {
          this.showSearchPeriode();
        }

        if (this.isShowDate == true) {
          this.isShowDate = true;

          let jenisParameter = "";
          if (this.selectedPeriode == "Custom") {
            jenisParameter = "custom";
          } else {
            jenisParameter = "periode";
          }

          this.$store.commit("addParameter", {
            jenis_parameter_glob: jenisParameter,
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: this.startDate,
            date_end_glob: this.endDate,
            data_source_glob: this.selectedSource,
            is_show_date_glob: this.isShowDate
          });
        }
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
        }
      }
    },
    async parameterProsesTopic() {
      var fromDate = this.startDate;
      var untilDate = this.endDate;

      this.topicKeywordSentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topicKeywordSentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            this.topicKeywordSentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
      this.selectedKeywords = ["All"];
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        data_source_glob: this.selectedSource,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesKeyword() {
      var fromDate = this.startDate;
      var untilDate = this.endDate;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        data_source_glob: this.selectedSource,
        is_show_date_glob: this.isShowDate
      });
      this.parameterProsesPeriode();
    },
    async parameterProsesPeriode() {
      let fromDate = this.startDate;
      let untilDate = this.endDate;
      if (this.selectedPeriode != 'Custom') {
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let dateGenerate = generateFilterDate(periode);
        fromDate = dateGenerate.start_date;
        untilDate = dateGenerate.end_date;
        this.startDate = fromDate;
        this.endDate = untilDate;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        data_source_glob: this.selectedSource,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesCustom() {
      this.selectedPeriode = "Custom";

      var fromDate = this.startDate;
      var untilDate = this.endDate;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        data_source_glob: this.selectedSource,
        is_show_date_glob: this.isShowDate
      });
    },
    showSearchPeriode() {
      var fromDate = this.startDate;
      var untilDate = this.endDate;
      let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
      let dateGenerate = generateFilterDate(periode);
      fromDate = dateGenerate.start_date;
      untilDate = dateGenerate.end_date;

      this.startDate = fromDate;
      this.endDate = untilDate;

      var date = new Date(this.startDate);
      var day2 = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      this.showStartDate = dateString.split(" ");

      var date3 = new Date(this.endDate);
      var day4 = `${(date3.getMonth() + 1).toString().padStart(2, '0')}/${date3.getDate().toString().padStart(2, '0')}/${date3.getFullYear()}`;
      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      this.showEndDate = dateString2.split(" ");

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.startDate,
        date_end_glob: this.endDate,
        data_source_glob: this.selectedSource,
        is_show_date_glob: this.isShowDate
      });
    },
    selectShowCustomDate() {
      this.isShowDate = true;

      var fromDate = this.startDate;
      var untilDate = this.endDate;

      this.startDate = fromDate;
      this.endDate = untilDate;

      var date = new Date(this.startDate);
      var day2 = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      this.showStartDate = dateString.split(" ");

      var date3 = new Date(this.endDate);
      var day4 = `${(date3.getMonth() + 1).toString().padStart(2, '0')}/${date3.getDate().toString().padStart(2, '0')}/${date3.getFullYear()}`;
      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      this.showEndDate = dateString2.split(" ");

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.startDate,
        date_end_glob: this.endDate,
        data_source_glob: this.selectedSource,
        is_show_date_glob: this.isShowDate
      });
    },
    async getSource() {
      try {
        const response = await axios.get("collection", {
          headers: { 'auth-token': localStorage.getItem("token_app") },
          dataType: "json",
        });

        this.itemsSource = response.data.token.data_collection
        .filter(item => item.STATUS == "Enabled")
        .map(item => ({
          ...item,
          valueNAME_SOCIAL_MEDIA: item.NAME_SOCIAL_MEDIA.toLowerCase(),
        }));

        if (Number.isInteger(this.selectedSource)) {
          for (let i = 0; i < this.itemsSource.length; i++) {
            if (this.selectedSource == this.itemsSource[i].ID) {
              this.selectedSource = this.itemsSource[i].valueNAME_SOCIAL_MEDIA;
              this.$store.data_source_glob = this.selectedSource;
            }
          }
        }

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch (error) {
        console.error("Error source:", error);
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.chat-wrapper {
  height: calc(100dvh - 147px);
  display: flex;
  flex-direction: column;
  background-color: #edebeb;
  overflow: hidden;
  border-radius: 4px;
}
@media (max-width: 600px) {
  .chat-wrapper {
    height: calc(100dvh - 110px);
    margin-right: 0 !important;
    margin-left: 0 !important;
    border-radius: 0;
  }
}
.chat-input-container {
  flex: 0 0 auto;
  padding: 0 4px 8px 4px;
  background: #edebeb;
}
@media (max-width: 600px) {
  .chat-input-container {
    position: sticky;
    bottom: 0;
    padding: 8px;
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    z-index: 10;
  }
  .chat-input-container .v-card {
    width: 100% !important;
    margin-left: 0 !important;
  }
}
.empty-chat-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
@media (max-width: 600px) {
  .empty-chat-container {
    justify-content: center;
    align-items: center;
    height: calc(100dvh - 320px);
    padding-top: 0;
    padding-bottom: 70px;
  }
  .empty-chat-container img {
    height: 120px !important;
    width: 120px !important;
  }
  .empty-chat-container h1 {
    font-size: 28px !important;
    text-align: center;
  }
}
.empty-chat-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .empty-chat-wrapper {
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }
}
.custom-disabled-btn-further-insights.v-btn.v-btn--disabled {
  color: var(--color-disabled-send) !important;
  opacity: 1 !important;
  border: 2px solid var(--color-disabled-send);
  pointer-events: none;
}
.custom-disabled-btn-further-insights.v-btn.v-btn--disabled .v-icon {
  color: var(--color-disabled-send) !important;
}
.custom-disabled-btn.v-btn.v-btn--disabled {
  background-color: var(--color-disabled-send) !important;
  opacity: 1 !important;
  color: white !important;
  pointer-events: none;
}
.custom-disabled-btn.v-btn.v-btn--disabled .v-icon {
  color: white !important;
}
.custom-date-picker ::v-deep .v-date-picker-table button {
  color: #000000 !important;
}
.custom-date-picker ::v-deep .v-date-picker-table button.v-btn--active {
  background-color: var(--color-theme) !important;
  color: #ffffff !important;
}
.hover-card:hover {
  background-color: #e3e3e3 !important;
}
.back-button {
  border: 1px solid var(--color-button-history);
  border-radius: 8px;
  height: 32px;
  width: 32px;
  min-height: 32px;
  min-width: 32px;
  padding: 0;
}
.new-chat-btn {
  background-color: var(--color-theme) !important;
  color: #fff;
  text-transform: none;
  font-size: 15px;
  border-radius: 12px;
  padding: 6px 12px;
}
.custom-list-item {
  cursor: pointer;
  background-color: var(--color-active-history);
  border-radius: 12px;
  margin-right: 5px;
  margin-left: 5px;
  padding-right: 10px;
  padding-left: 10px;
}
.hover-list-item {
  cursor: pointer;
  background-color: var(--color-hover-history);
  border-radius: 12px;
  margin-right: 5px;
  margin-left: 5px;
  padding-right: 10px;
  padding-left: 10px;
}
.border-right {
  position: relative;
}
.border-right::before {
  content: "";
  background-color: #0000001F;
  position: absolute;
  top: 5px;
  right: 0;
  height: calc(100% - 10px);
  width: 1px;
}
.periode-info {
  text-align: right;
  margin-left: auto;
  margin-right: 32px;
  margin-bottom: 20px;
  min-width: 300px;
}
.loading-dots {
  color: var(--color-theme);
  font-size: 32px;
  font-weight: bold;
  display: inline-flex;
}
.loading-dots span {
  animation: blink 1.5s infinite;
  margin: 0 2px;
}
.loading-dots span:nth-child(1) { animation-delay: 0s; }
.loading-dots span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes blink {
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
}
.response-container-question {
  margin-right: 18px;
  margin-bottom: 20px;
  width: 100%;
}
.response-text-question {
  background-color: var(--color-theme);
  color: #fff;
  float: right;
  white-space: pre-line;
  max-width: 60%;
  border-radius: 10px;
  padding: 10px 15px;
}
.response-container-message {
  width: 99%;
  overflow-x: auto;
}
.response-text-message {
  background: #f4f4f4;
  overflow-x: auto;
  display: block;
  max-width: 100%;
  border-radius: 8px;
  line-height: 1.6;
  padding: 10px;
}
.response-text-message strong {
  display: block;
  margin-bottom: 4px;
}
.response-text-message ul {
  margin-top: 4px;
  padding-left: 20px;
}
.custom-textarea ::v-deep(.v-input__control) {
  background-color: transparent !important;
  min-height: unset !important;
}
.custom-textarea ::v-deep(.v-input__slot) {
  background-color: transparent !important;
  min-height: unset !important;
  margin-bottom: 0 !important;
}
.custom-textarea ::v-deep(.v-text-field__slot) {
  margin-top: 0 !important;
}
.custom-textarea ::v-deep(textarea) {
  color: grey !important;
  padding-top: 2px !important;
  padding-bottom: 8px !important;
}
.custom-textarea ::v-deep(textarea::placeholder) {
  color: grey !important;
}
.custom-textarea ::v-deep(.v-text-field fieldset) {
  border-color: grey !important;
  transition: border-color 0.3s ease !important;
}
</style>
